import React from 'react';

function Loader() {
  return <div className="flex justify-center items-center h-screen">Loading...</div>;
}

export default Loader;